import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const StarBurstFull: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg width="216" height="215" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke="#FFCD85" strokeMiterlimit="10">
        <path
          d="M175.761 71.605 150.87 84.93M146.494 43.712l-14.18 23.6M106.888 33.027l.142 10.28M186.841 109.22l-10.57-.174M183.871 89.809l-22.273 5.306M163.004 55.898l-21.412 20.223M121.625 57.164l5.723-21.232"
          strokeWidth="4"
        />
        <path
          d="m150.872 84.93-28.743 15.363M132.315 67.313l-16.333 27.145M107.031 43.308l.58 43.203M76.587 57.056l-9.026-14.658M176.78 146.484l-14.6-8.165M176.272 109.045l-45.715-.75M184.422 128.568l-45.438-12.271M161.6 95.116l-35.915 8.555M141.594 76.122l-22.539 21.254M121.625 57.163 112.443 91.1M86.49 35.235l12.77 43.348"
          strokeOpacity=".5"
          strokeWidth="1.5"
        />
        <path
          d="m29.177 106.393 10.342.172M40.258 144.007l24.759-13.236M83.631 148.443 69.525 171.9M108.993 172.521l.138 10.064M32.13 125.821l22.12-5.272M52.996 159.732l21.318-20.135M94.36 158.629l-5.707 21.07"
          strokeWidth="4"
        />
        <path
          d="m39.146 69.22 13.544 7.59M39.637 106.677l45.296.743M65.035 130.791l28.48-15.223M83.593 148.409l16.185-26.894M108.876 172.413l-.574-42.806M139.964 159.667l8.402 13.637M31.504 87.136 76.33 99.254M54.308 120.606l35.573-8.487M74.314 139.6l22.333-21.058M94.282 158.558l9.111-33.611M116.827 137.701l12.608 42.767"
          strokeOpacity=".75"
          strokeWidth="1.5"
        />
        <path
          d="m107.905 107.904 14.221-7.611M115.979 94.457l-8.074 13.448M107.609 86.51l.296 21.395M76.584 57.055l31.32 50.849M107.906 107.905l-54.81-30.71M107.904 107.904l-22.858-.375M107.905 107.904l-14.371 7.682M107.906 107.905l-8.167 13.572M107.906 107.905l.299 21.611M139.539 159.264l-31.633-51.359M162.177 138.318l-54.272-30.414M107.905 107.904l22.648.39M107.905 107.904l31.076 8.391M107.905 107.904l17.777-4.235M107.905 107.904l11.147-10.53M112.44 91.098l-4.536 16.806M99.258 78.582l8.647 29.322M107.904 107.904l-31.382-8.468M107.905 107.904l-17.948 4.286M107.905 107.904l-11.26 10.636M107.906 107.905l-4.591 16.968M116.633 137.517l-8.727-29.612"
          strokeOpacity=".15"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export { StarBurstFull };
